module.exports = __webpack_public_path__ + "static/img/title-bk.eca127d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/title-bk.png
// module id = EAmp
// module chunks = 39